module.exports = __webpack_public_path__ + "img/hud-darken.dd7c5f72.png";